import React, { useRef } from 'react' 
import CustomHook from './CustomHook';
function Home() {
const scrollTab = useRef();
CustomHook(scrollTab);

return (
    <section ref={scrollTab} className='home'>
        <div className="content">
            <div className="name">
                MY NAME IS <span>Aditya</span>
            </div>
            <div className="des">
                {/* 30 */}
                Aditya Patel, an aspiring explorer from Gorakhpur, Uttar Pradesh, is currently pursuing a BBA in Human Resources at Galgotias University. With a passion for discovery and learning, Aditya aims to blend his academic journey with a global perspective, bringing valuable insights to the field of human resources.!
            </div>
            
            <a href="/democv.pdf" target="_blank" rel="noopener noreferrer" className='animation active '>
                Download My CV
            </a>
        </div>
        <div className="avatar">
            <div className="card">
                <img src="/avatar.jpg" alt="" />
                <div className="info">
                    <div>Explorer</div>
                    <div>explorewithadi</div>
                    <div>03/12</div>
                    <div>Male</div>
                </div>
            </div>
        </div>
    </section>
    )
}

export default Home
